import { Icon } from '@iconify/react';
import { fmtDate } from '../visitorConstants';

// Blocking is advisory at the visitor layer: the record carries the flag and an
// activity log entry, but the visit-creation flow is what actually stops
// someone. Saying that here keeps "Blocked" from reading as "the gate is
// sealed".
const VisitorBlockedBanner = ({ visitor, canUpdate, busy, onUnblock }) => (
    <div className="tw-flex tw-flex-wrap tw-items-start tw-gap-2 tw-px-4 tw-py-3 tw-rounded-xl tw-bg-rose-50 tw-border tw-border-rose-200 tw-text-rose-800">
        <Icon icon="mdi:block-helper" className="tw-text-lg tw-shrink-0" />
        <div className="tw-flex-1 tw-min-w-[200px]">
            <p className="tw-mb-0 tw-text-xs tw-font-bold">This visitor is blocked</p>
            <p className="tw-mb-0 tw-text-[11px] tw-mt-0.5">
                {visitor.blocked_reason || 'No reason was recorded.'}
            </p>
            <p className="tw-mb-0 tw-text-[10px] tw-text-rose-600 tw-mt-1">
                Blocked on {fmtDate(visitor.blocked_at)}
                {visitor.blocked_by ? ` · by user #${visitor.blocked_by}` : ''}
                {' · enforced when a visit is created'}
            </p>
        </div>
        {canUpdate && (
            <button
                onClick={onUnblock}
                disabled={busy}
                className="tw-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-text-xs tw-font-medium tw-text-white tw-bg-emerald-600 hover:tw-bg-emerald-700 tw-rounded-md disabled:tw-opacity-50"
            >
                <Icon icon="mdi:lock-open-variant-outline" className="tw-text-sm" />
                Unblock
            </button>
        )}
    </div>
);

export default VisitorBlockedBanner;
